import { render, staticRenderFns } from "./datenschutz.vue?vue&type=template&id=3efb8d50&scoped=true&"
import script from "./datenschutz.vue?vue&type=script&lang=js&"
export * from "./datenschutz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb8d50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Ampps/www/passwort-generator-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VProgressLinear})
